import { isBrowser } from "appConfiguration";

export function checkCaptureEnvironmentSupport(): boolean {
  if (!isBrowser) {
    return false;
  }
  const inputEl = document.createElement("input");
  return "capture" in inputEl;
}
